import { sendSentryError } from '@lib/sentry';

const API_ENDPOINT = `${process.env.NEXT_PUBLIC_WORDPRESS_API_URL}/wp-json/post-views-counter/view-post`;

export const viewPost = async (databaseId: number) => {
  try {
    const data = new URLSearchParams();
    data.append('id', databaseId.toString());

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      body: data,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
  } catch (error) {
    console.error('[View Count] 에러:', error);
    sendSentryError({
      error,
      extra: { databaseId },
      source: 'view-post',
    });
  }
};
